import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import styles from '../styles'
import { FormControlLabel, Grid, Switch } from '@material-ui/core'
import Button from 'components/theme/Button'
import { paste, defaultValueChange } from 'actions/template'
import { Delete } from '@material-ui/icons'
import {
  removeSection,
  setImageSize,
  clickCodeButton,
  selectSection,
  setImageDimension,
  setImageUrlWrapper,
  setImage,
} from 'actions/template'
import Body from './Body'
import CodeEditor from './CodeEditor'
import Field from 'components/theme/Field'
import { getCustomAttributes } from 'actions/contacts'

const editorMap = {
  wysiwyg: 'wysiwyg',
  header: 'wysiwyg',
  divider: 'wysiwyg',
  paragraph: 'wysiwyg',
  'image-paragraph': 'wysiwyg',
  '2-columns-image-paragraph': 'wysiwyg',
  '3-columns-image-paragraph': 'wysiwyg',
  'image-banner-text': 'wysiwyg',
}

class Editor extends Component {
  componentDidMount() {
    if (!this.props.customAttributes) {
      this.props.getCustomAttributes()
    }
  }

  render() {
    return (
      <div
        style={{
          width: '100%',
          maxHeight: 1136,
          overflowY: 'auto',
        }}
      >
        {this.props.codeEditorDisplayed ? (
          <span>
            <CodeEditor height="550px" />
            {editorMap?.[this.props.editor] === 'wysiwyg' && (
              <Button
                style={{
                  margin: '8px 17px',
                }}
                onClick={() => this.props.clickCodeButton()}
              >
                {this.props.codeEditorDisplayed ? 'Edit Section' : 'Edit code'}
              </Button>
            )}
          </span>
        ) : (
          <>
            <Grid
              container
              style={{
                padding: '10px',
                maxHeight: 927,
              }}
            >
              <Grid
                style={{
                  height: '100%',
                  maxHeight: 907,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  paddingTop: '15px',
                }}
                item
                xs={12}
              >
                <div
                  style={
                    !this.props.wysiwyg
                      ? {
                          height: '100%',
                        }
                      : {
                          display: 'none',
                        }
                  }
                >
                  <Body />
                </div>
              </Grid>
            </Grid>
            {this.props.editor === 'img-picker' && (
              <>
                <div // style={{ padding: '0 10px' }}
                  className={this.props.classes.widthAndHeight}
                >
                  <div
                    style={{
                      width: '50%',
                      display: 'inline-block',
                      padding: '0 5px',
                    }}
                  >
                    <Field
                      label="Width px (max: 600)"
                      property="width" // handleChangeFuncPath="actions/template"
                      // handleChangeFunc="setImageDimension"
                      handleChange={this.props.setImageDimension}
                      valuePath={state => state.email.image.width}
                    />
                  </div>
                  <div
                    style={{
                      width: '50%',
                      display: 'inline-block',
                      padding: '0 5px',
                    }}
                  >
                    <Field
                      label="Height px"
                      property="height" // handleChangeFuncPath="actions/template"
                      // handleChangeFunc="setImageDimension"
                      handleChange={this.props.setImageDimension}
                      valuePath={state => state.email.image.height}
                    />
                  </div>
                  <div
                    style={{
                      // width: '33.33%',
                      display: 'inline-block',
                      verticalAlign: 'text-top',
                      padding: '0 5px',
                    }}
                  >
                    <FormControlLabel
                      label="Keep image proportions"
                      control={
                        <Switch
                          checked={this.props.checked}
                          onChange={e => {
                            console.log(e.target.checked)
                            this.props.setImageDimension(
                              'fixed',
                              e.target.checked,
                            )
                          }}
                        />
                      }
                    />
                  </div>
                </div>
              </>
            )}
            <Grid
              style={{
                padding: 10,
              }}
              container
              justify="space-between"
            >
              <Grid item>
                {editorMap?.[this.props.editor] === 'wysiwyg' && (
                  <Button onClick={() => this.props.clickCodeButton()}>
                    {this.props.codeEditorDisplayed
                      ? 'Edit Section'
                      : 'Edit code'}
                  </Button>
                )}
                {this.props.editor === 'img-picker' && (
                  <Button
                    onClick={() => {
                      this.props.setImage() // setImageUrlWrapper()
                      // selectSection(null)
                    }}
                    style={{
                      backgroundColor: '#15b940',
                      color: '#fff',
                    }}
                  >
                    Apply changes
                  </Button>
                )}
              </Grid>
              <Grid item>
                <Button
                  onClick={() =>
                    window.confirm(
                      'Are you sure you want to delete this section?',
                    ) && this.props.removeSection(this.props.sectionSelected)
                  }
                  color="primary"
                >
                  <Delete
                    style={{
                      marginRight: 5,
                    }}
                  />
                  Delete
                </Button>
                <Button
                  onClick={() => {
                    // if (editor === 'img-picker') {
                    // 	setImageSize()
                    // } else {
                    this.props.selectSection(null) // }
                  }}
                  color="primary"
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </>
        )}
      </div>
    )
  }
}

export default connect(
  state => ({
    codeEditorDisplayed: state.email.codeEditorDisplayed,
    defaultValues: state.email.defaultValues,
    sectionSelected: state.email.sectionSelected,
    editor:
      typeof state.email.sectionSelected === 'number' &&
      state.email.sections[state.email.sectionSelected] &&
      state.email.sections[state.email.sectionSelected].editor,
    wysiwyg:
      state.email.sections[state.email.sectionSelected] &&
      state.email.sections[state.email.sectionSelected].editor === 'wysiwyg',
    checked: state.email.image.fixed,
    customAttributesLength: state.contacts.customAttributes.length,
  }),
  dispatch =>
    bindActionCreators(
      {
        paste,
        defaultValueChange,
        removeSection,
        selectSection,
        setImageSize,
        clickCodeButton,
        setImageDimension,
        setImageUrlWrapper,
        setImage,
        getCustomAttributes,
      },
      dispatch,
    ),
)(withStyles(styles)(Editor))
